
export enum OperationResultEnum  {
    SYSTEM_ERROR= -1,
    VALIDATION_FAILED= -2,
    SESSION_TIMEOUT= -3,
    OPERATION_FAILED= -4,
    SUCCESS= 1
}

export enum OperationStatus 
    {
        SUCCESS = 200,
        NOTFOUND =404
    }
